import { spacingPrimitive } from "./spacingPrimitive";

export const spacingWidth = {
	width_xxs: spacingPrimitive[80],
	width_xs: spacingPrimitive[96],
	width_sm: spacingPrimitive[120],
	width_md: spacingPrimitive[140],
	width_lg: spacingPrimitive[160],
	width_xl: spacingPrimitive[192],
	width_2xl: spacingPrimitive[256],
	width_3xl: spacingPrimitive[320],
	width_4xl: spacingPrimitive[360],
	width_5xl: spacingPrimitive[400],
	width_6xl: spacingPrimitive[480],
	paragraph_max_width: spacingPrimitive[180],
};
